import {
  DEFAULT_ERR,
  GET_NOTIFICATION_COUNT_REQUEST,
  GET_NOTIFICATION_COUNT_SUCCESS,
  GET_NOTIFICATION_COUNT_FAILED,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILED,
  READ_NOTIFICATIONS_REQUEST,
  READ_NOTIFICATIONS_SUCCESS,
  READ_NOTIFICATIONS_FAILED,
} from '../types';
import API from '../../apiConfig';

import { setAlert } from './alert';

// GET Notification count
export const getNotificationCount = (supplierId) => async (dispatch) => {
  dispatch({
    type: GET_NOTIFICATION_COUNT_REQUEST,
  });
  try {
    API.get(`supplier/notification/count?supplierId=${supplierId}`)
      .then((res) => {
        dispatch({
          type: GET_NOTIFICATION_COUNT_SUCCESS,
          response: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_NOTIFICATION_COUNT_FAILED,
          message: err.message,
        });
        dispatch(setAlert(err.message, 'error'));
      });
  } catch (err) {
    dispatch({
      type: GET_NOTIFICATION_COUNT_FAILED,
      message: DEFAULT_ERR,
    });
    dispatch(setAlert(DEFAULT_ERR, 'error'));
  }
};

// GET Notifications
export const getNotifications = (supplierId) => async (dispatch) => {
  dispatch({
    type: GET_NOTIFICATIONS_REQUEST,
  });
  try {
    API.get(`supplier/notification?supplierId=${supplierId}`)
      .then((res) => {
        dispatch({
          type: GET_NOTIFICATIONS_SUCCESS,
          response: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_NOTIFICATIONS_FAILED,
          message: err.message,
        });
        dispatch(setAlert(err.message, 'error'));
      });
  } catch (err) {
    dispatch({
      type: GET_NOTIFICATIONS_FAILED,
      message: DEFAULT_ERR,
    });
    dispatch(setAlert(DEFAULT_ERR, 'error'));
  }
};

// READ ALL Notifications
export const readAllNotification = (supplierId) => async (dispatch) => {
  dispatch({
    type: READ_NOTIFICATIONS_REQUEST,
  });
  try {
    API.post('supplier/notification/readAll', { supplierId })
      .then((res) => {
        dispatch({
          type: READ_NOTIFICATIONS_SUCCESS,
          response: res.data,
        });
        dispatch(getNotificationCount(supplierId));
      })
      .catch((err) => {
        dispatch({
          type: READ_NOTIFICATIONS_FAILED,
          message: err.message,
        });
        dispatch(setAlert(err.message, 'error'));
      });
  } catch (err) {
    dispatch({
      type: READ_NOTIFICATIONS_FAILED,
      message: DEFAULT_ERR,
    });
    dispatch(setAlert(DEFAULT_ERR, 'error'));
  }
};
